import { Component, Input } from '@angular/core';

import { AutoPayUtilService } from '@amfam/billing/auto-pay/feature';
import { BillAccount } from '@amfam/shared/models';
import { Applications, ApplicationService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'ds-billing-preferences',
  templateUrl: './billing-preferences.component.html',
  styleUrls: ['./billing-preferences.component.scss'],
  standalone: false
})
export class BillingPreferencesComponent {
  @Input()
  billAccount: BillAccount;

  @Input()
  hasAutopayEnabled;

  @Input()
  autopayEligible;

  public isAdminApp = this.applicationService.isApp(Applications.MYACCOUNT_ADMIN);

  constructor(
    private applicationService: ApplicationService,
    private autoPayUtil: AutoPayUtilService
  ) {}

  public navigateToAutoPay() {
    // AUTOPAY ENTRY POINT
    this.autoPayUtil.addAutoPay(
      this.billAccount.billAccountNumber,
      `/billing/${this.billAccount.billAccountNumber}`
    );
  }
}
